import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from 'src/apis/HttpBaseApiWrapper';
import { useStudentsService } from 'src/apis/students/useStudentsService';
import { IStudentAssessmentListApiResponse } from 'src/apis/students/studentsAssessment.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getStudentSubjectBasedStudentAssessmentListKey =
  'get-student-subject-based-student-assessment-list';

export const useStudentSubjectBasedStudentAssessmentListHook = (
  id: string,
  options?: UseQueryOptions<IStudentAssessmentListApiResponse, TQueryError>
): UseQueryResult<IStudentAssessmentListApiResponse, TQueryError> => {
  const { getStudentSubjectBasedStudentAssessmentList } = useStudentsService();

  return useQuery<IStudentAssessmentListApiResponse, TQueryError>({
    queryKey: [getStudentSubjectBasedStudentAssessmentListKey, id],
    queryFn: () => getStudentSubjectBasedStudentAssessmentList(id),
    enabled: true,
    ...options,
  });
};
